import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import style from './LayoutContainer.module.scss.js';

const { componentTestLabel } = getTestLabels('LayoutContainer');
/**
 * [design (Figma)](https://www.figma.com/file/ZxcgCXonHvmYETNpUB95wQ/Foundations-WIP?type=design&node-id=5729-90184&mode=design&t=8zT81DV1bMLRXSVN-0)
 * | [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Layout/LayoutContainer/LayoutContainer.tsx)
 *
 * @param {string} [variant="default"] - (optional) One of `default` (default), `inert`, or `narrow`.
 */
const LayoutContainer = forwardRef((props, ref) => {
    const { children, className, variant = 'default', ...otherProps } = props;
    return (jsx("div", { "data-zta": componentTestLabel, "data-variant": variant, ref: ref, className: classNames(className, style['z-layout-container'], {
            [style[`z-layout-container--${variant}`]]: variant !== 'default',
        }), ...otherProps, children: children }));
});
LayoutContainer.displayName = 'LayoutContainer';

export { LayoutContainer };
//# sourceMappingURL=LayoutContainer.js.map
